module.exports = __webpack_public_path__ + "static/media/newsletter-tool-logo.0596fcb6.svg";